import {
    createRestClient,
    RestClient,
} from '@superbet-group/web.lib.rest';

import { defaultHttpTimeoutMs } from '@core/constants';
import {
    getConfig,
    getRawRemoteConfig,
} from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';

export default class RestService {
    private readonly restClient: RestClient;

    constructor() {
        let baseUrl;
        let legacyWebBackendUrl = getRawRemoteConfig().legacyWebBackend || getRawRemoteConfig().newWebBackend;

        if (getConfig().countrySpecific.country === Country.RoNapoleon) {
            legacyWebBackendUrl = new URL(`${String(getConfig().user.host)}/legacy-web/user`);
        }

        try {
            let legacyWebUrl = new URL(`${String(legacyWebBackendUrl)}/user`);

            if (!(getConfig().countrySpecific.country === Country.Ro
                || getConfig().countrySpecific.country === Country.Pl)) {
                legacyWebUrl = new URL(`${String(getConfig().user.host)}/api/v1`);
            }

            // replace the domain name with the current hostname so this call only does same site requests
            legacyWebUrl.hostname = [
                ...legacyWebUrl.hostname.split('.').slice(0, -2),
                ...window.location.hostname.split('.').slice(-2),
            ].join('.');
            baseUrl = legacyWebUrl.href;
        } catch {
            baseUrl = `${legacyWebBackendUrl}/user`;
        }

        // TODO: fix config to remove this sanitizer for duplicate slashes in the URL (.bet.br pord only issue)
        function sanitizeUrl(url: string) {
            return url.replace(/([^:]\/)\/+/g, '$1');
        }

        baseUrl = sanitizeUrl(baseUrl);
        this.restClient = createRestClient(baseUrl, defaultHttpTimeoutMs, true);
    }

    public getZendeskToken({
        email,
        name,
        id,
    }: {
        email: string;
        name: string;
        id: string;
    }): Promise<any> {
        return this.restClient.post('/createZendeskJwt', {
            email,
            username: name,
            external_id: String(id),
        });
    }
}
